module.exports = __webpack_public_path__ + "img/youtube.c9cd56f1.svg";